module.exports = __webpack_public_path__ + "static/media/google_induction_icon.5e88a450.svg";